import { useEffect } from 'react';
import { useAppSelector } from '@/app/hooks';
import { logging } from '@/services/logging';

export const useLogging = () => {
  const userId = useAppSelector(state => state.auth.user?.id ?? null);
  const anonymousId = useAppSelector(state => state.auth.temporaryUserId ?? null);

  useEffect(() => {
    logging.setIdentity({ userId, anonymousId });
  }, [userId, anonymousId]);

  return logging;
};
